import { ADD_WISHLIST, ADD_WISHLIST_FAIL, DELETE_WISHLIST, FETCH_WISHLIST } from "store/types";

const initialState = [];

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_WISHLIST:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_WISHLIST:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_WISHLIST_FAIL:
      return {
        ...state,
        ...action.payload,
      };
    case DELETE_WISHLIST:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
